import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
// import Fruit from '../components/Fruit'
// import Fashion from '../components/Fashion'
// import Fashion1 from '../components/Fashion1'
// import Fashion2 from '../components/Fashion2'
// import Fashion3 from '../components/Fashion3'
// import Marketing from '../components/Marketing'
import Cooperation from '../components/Cooperation'
// import About from '../components/About'
import CompanyProfile from '../components/CompanyProfile'
import Originator from '../components/Originator'
import NewsList from '../components/NewsList';
import StoreEarnings from '../components/StoreEarnings';
import ScanBox from '../components/ScanBox';   //扫码盒
import StoreTag from '../components/StoreTag';  //店收盈码牌
import LoudspeakerBox from '../components/LoudspeakerBox'; //店收盈音箱
import GuestDisplay from '../components/GuestDisplay'; //客显屏音箱
import SmartPOS from '../components/SmartPOS'; //智能POS
import Customization from '../components/Customization'; //定制云打印机
import NewsDetail from "../components/NewsDetail";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            meta:{
              type:1,
            },
            // component: Index
            component: () => import('@/components/Index'),
        },
        // {
        //     path: '/fruit',
        //     name: 'Fruit',
        //     component: Fruit
        // },
        // {
        //     path: '/fashion',
        //     name: 'Fashion',
        //     component: Fashion
        // },
        // {
        //     path: '/fashion1',
        //     name: 'Fashion1',
        //     component: Fashion1
        // },
        // {
        //     path: '/fashion2',
        //     name: 'Fashion2',
        //     component: Fashion2
        // },
        // {
        //     path: '/fashion3',
        //     name: 'Fashion3',
        //     component: Fashion3
        // },
        // {
        //     path: '/marketing',
        //     name: 'Marketing',
        //     component: Marketing
        // },
        // {
        //     path: '/about',
        //     name: 'About',
        //     component: About
        // },
        {
            path: '/cooperation',
            name: 'Cooperation',
            meta:{
              type: 3,
            },
            // component: Cooperation
            component: () => import('@/components/Cooperation'),
        },
        {
          path: '/companyprofile',
          name: 'CompanyProfile',
          meta:{
            type: 4,
          },
          // component: CompanyProfile
          component: () => import('@/components/CompanyProfile'),
        },
        {
          path: '/originator',
          name: 'Originator',
          meta:{
            type: 4,
          },
          // component: Originator
          component: () => import('@/components/Originator'),
        },
        {
          path: '/newsList',
          name: 'NewsList',
          meta:{
            type: 4,
          },
          // component: NewsList
          component: () => import('@/components/NewsList'),
        },
        {
          path: '/storeEarnings',
          name: 'StoreEarnings',
          meta:{
            type: 2,
          },
          // component: StoreEarnings
          component: () => import('@/components/StoreEarnings'),
        },
        {
          path: '/scanBox',
          name: 'ScanBox',
          meta:{
            type: 2,
          },
          // component: ScanBox
          component: () => import('@/components/ScanBox'),
        },
        {
          path: '/storeTag',
          name: 'StoreTag',
          meta:{
            type: 2,
          },
          // component: StoreTag
          component: () => import('@/components/StoreTag'),
        },
        {
          path: '/loudspeakerBox',
          name: 'LoudspeakerBox',
          meta:{
            type: 2,
          },
          // component: LoudspeakerBox
          component: () => import('@/components/LoudspeakerBox'),
        },
        {
          path: '/guestDisplay',
          name: 'GuestDisplay',
          meta:{
            type: 2,
          },
          // component: GuestDisplay
          component: () => import('@/components/GuestDisplay'),
        },
        {
          path: '/smartPOS',
          name: 'SmartPOS',
          meta:{
            type: 2,
          },
          // component: SmartPOS
          component: () => import('@/components/SmartPOS'),
        },
        {
          path: '/customization',
          name: 'Customization',
          meta:{
            type: 2,
          },
          // component: Customization
          component: () => import('@/components/Customization'),
        },
        {
          path: '/newsDetail',
          name: 'NewsDetail',
          meta:{
            type: 4,
          },
          // component: NewsDetail
          component: () => import('@/components/NewsDetail'),
        },
        {
          path: '/frameWork',
          name: 'FrameWork',
          meta:{
            type: 4,
          },
          component: () => import('@/components/FrameWork'),
        },
        {
          path: '/yldDetail',
          name: 'YLDDetail',
          meta:{
            type: 4,
          },
          component: () => import('@/components/YLDDetail'),
        },
        {
          path: '/xllDetail',
          name: 'XLLDetail',
          meta:{
            type: 4,
          },
          component: () => import('@/components/XLLDetail'),
        }
    ],
    scrollBehavior(to, from, savedPosition) {
      // 始终滚动到顶部
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },
})
